import React, {  useState } from 'react';
import { TextField, Grid, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';
import { GlobalData } from '../util/GlobalData';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';


export default function OpeningHours({ hours, setHours, viewOnly }) {
    const [openingHours, setOpeningHours] = useState(
        hours ? deserializeOpeningHours(hours) :
            GlobalData.user.daysOfWeek.reduce((acc, day) => {
                acc[day] = { open: false, from: null, to: null };
                return acc;
            }, {})
    )
    const { t } = useTranslation()



    const handleDayChange = (day, field, value) => {
        const newOpeningHours = { ...openingHours }
        newOpeningHours[day][field] = value



        setOpeningHours(newOpeningHours)
        setHours(serializeOpeningHours(newOpeningHours))
    };


    function serializeOpeningHours(hours) {
        const serialized = {};
        for (const day in hours) {
            const entry = hours[day];
            serialized[day] = {
                open: entry.open,
                from: entry.from ? entry.from.toISOString() : null,
                to: entry.to ? entry.to.toISOString() : null
            };
        }
        return JSON.stringify(serialized);
    }


    function deserializeOpeningHours(serialized) {
        const hours = JSON.parse(serialized);
        const deserialized = {};
        for (const day in hours) {
            const entry = hours[day];
            deserialized[day] = {
                open: entry.open,
                from: entry.from ? dayjs(entry.from) : null,
                to: entry.to ? dayjs(entry.to) : null
            };
        }
        return deserialized;
    }

    if (viewOnly) {
        return (
            <>
                {GlobalData.user.daysOfWeek.map((day, index) => (
                    <div key={index}>
                        <Grid container alignItems="center">
                            <Grid item xs={4}>
                                <Typography sx={{fontWeight:"bold"}}>{t("user.daysOfWeek." + day)}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                {openingHours[day].open ?
                                    <Typography color="primary">{t("user.open")}</Typography>
                                    :
                                    <Typography color="error">{t("user.closed")}</Typography>
                                }
                            </Grid>
                            <Grid item xs={4}>
                                {openingHours[day].open ?
                                    <Typography variant="body1">
                                        {`${(openingHours[day].from).format('h:mm A')} - ${(openingHours[day].to).format('h:mm A')}`}
                                    </Typography>
                                    :
                                    ""
                                }
                            </Grid>
                        </Grid>
                        {index!=GlobalData.user.daysOfWeek.length-1 && <hr className='mb-1 mt-1' />}
                    </div>
                ))}
            </>
        )
    } else
        return (
            <>
                {GlobalData.user.daysOfWeek.map((day, index) => (
                    <div key={index}>
                        <Grid container alignItems="center">
                            <Grid item xs={4}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={openingHours[day].open}
                                            onChange={(e) => handleDayChange(day, 'open', e.target.checked)}
                                        />
                                    }
                                    label={t("user.daysOfWeek." + day)}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                {openingHours[day].open && (
                                    <TimePicker
                                        label={t("user.from")}
                                        value={openingHours[day].from}
                                        onChange={(newValue) => handleDayChange(day, 'from', newValue)}
                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={4}>
                                {openingHours[day].open && (
                                    <TimePicker
                                        label={t("user.to")}
                                        value={openingHours[day].to}
                                        onChange={(newValue) => handleDayChange(day, 'to', newValue)}
                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                    />
                                )}
                            </Grid>
                        </Grid>
                        {index!=GlobalData.user.daysOfWeek.length-1 && <hr className='mb-1 mt-1' />}
                    </div>
                ))}
            </>
        );
}